import { sellerAdjustmentTypeApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SELLER_ADJUSTMENT_TYPES_ACTION_TYPE = createNamedActions('sellerAdjustmentTypes', {
  GET_TYPES: 'GET_TYPES',
  CREATE_TYPE: 'CREATE_TYPE',
  EDIT_TYPE: 'EDIT_TYPE',
  DELETE_TYPE: 'DELETE_TYPE',
});

const sellerAdjustmentTypesSchema = new schema.Entity(
  'data',
  {},
  { idAttribute: 'sellerAdjustmentTypeId' },
);

export const getSellerAdjustmentTypesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await sellerAdjustmentTypeApi.getTypes(params);

  return dispatch({
    type: SELLER_ADJUSTMENT_TYPES_ACTION_TYPE.GET_TYPES,
    payload: normalize(data, [sellerAdjustmentTypesSchema]).entities.data,
  });
});

export const createSellerAdjustmentTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await sellerAdjustmentTypeApi.createType(params);

  return dispatch({
    type: SELLER_ADJUSTMENT_TYPES_ACTION_TYPE.CREATE_TYPE,
    payload: data,
  });
});

export const editSellerAdjustmentTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await sellerAdjustmentTypeApi.editType(params);

  return dispatch({
    type: SELLER_ADJUSTMENT_TYPES_ACTION_TYPE.EDIT_TYPE,
    payload: data,
  });
});

export const deleteSellerAdjustmentTypeAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await sellerAdjustmentTypeApi.deleteType(params);

  return dispatch({
    type: SELLER_ADJUSTMENT_TYPES_ACTION_TYPE.DELETE_TYPE,
    payload: data,
    meta: params,
  });
});
